<template>
  <v-layout
    v-if="!isSheetReflectionLoading && !isSheetMeetingLoading"
    id="content-area"
    column
    pa-3
    fill-height
  >
    <incomeCalculation v-view="viewHandler" />
    <SeniorReflection
      v-if="showSeniorPack"
      v-view="viewHandler"
      :read-only="readOnly"
    />
    <MeetingSummary
      v-view="viewHandler"
      :read-only="readOnly"
    />
    <ReflectionResources
      v-if="!isCurrentEdition"
      v-view="viewHandler"
      :read-only="readOnly"
    />
    <ReflectionBarriers
      v-view="viewHandler"
      :read-only="readOnly"
    />
    <SolutionSummary
      v-if="!isCurrentEdition"
      v-view="viewHandler"
      :read-only="readOnly"
    />
    <sheetEndButtons
      :sheet-type="'reflection'"
      :family-id="$route.params.familyId"
      to="sheet-one-decision"
      next-section-name="Decyzji"
      :read-only="readOnly"
      :scroll-button="true"
      :can-do-audit-in-area="canDoAuditInArea"
      :can-do-audit-on-national="canDoAuditOnNational"
      :national-correcting-permission="hasPermissionsForNationalCorrecting"
    />
    <leaveConfirmDialog ref="confirm" />
    <FamilyAudit
      v-if="showAuditCard"
      :can-add-comment="canAddComment"
      :family-id="$route.params.familyId"
      :sheet-type="'reflection'"
      :comment-level="commentLevel"
      :has-permissions-to-add-comment="hasPermissionsToAddComment"
    />
  </v-layout>
  <PageLoader v-else />
</template>

<script>
import IncomeCalculation from '@/components/sheet/sheetOne/reflection/IncomeCalculation';
import SeniorReflection from '@/components/sheet/sheetOne/reflection/SeniorReflection';
import MeetingSummary from '@/components/sheet/sheetOne/reflection/MeetingSummary';
import ReflectionResources from '@/components/sheet/sheetOne/reflection/ReflectionResources';
import ReflectionBarriers from '@/components/sheet/sheetOne/reflection/ReflectionBarriers';
import SolutionSummary from '@/components/sheet/sheetOne/reflection/SolutionSummary';
import sheetEndButtons from '@/components/widgets/sheet/sheetEndButtons';
import leaveConfirmDialog from '@/components/widgets/LeaveConfirmDialog';
import FamilyAudit from '@/components/audit/FamilyAudit';

import permissions from '@/constants/permissions';

import sheetBeforeLeave from '@/mixins/sheetBeforeLeave';
import auditPermissionsAndStatuses from '@/mixins/auditPermissionsAndStatuses';
import isFamilyChecked from '@/mixins/sheet/isFamilyChecked';
import PageLoader from '@/components/widgets/PageLoader';
import postMeetingConsent from '@/constants/sheet/postMeetingConsent';

export default {
    name: 'SheetReflection',
    components: {
        PageLoader,
        IncomeCalculation,
        sheetEndButtons,
        SeniorReflection,
        MeetingSummary,
        ReflectionResources,
        ReflectionBarriers,
        SolutionSummary,
        leaveConfirmDialog,
        FamilyAudit
    },
    mixins: [sheetBeforeLeave, auditPermissionsAndStatuses, isFamilyChecked, postMeetingConsent],
    $_veeValidate: {
        validator: 'new'
    },
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            vm.$store.dispatch('sheet/getSheetPermissions', vm.$route.params.familyId);
            vm.$store
                .dispatch('sheet/loadSheet', {
                    familyId: vm.$route.params.familyId,
                    sheetType: 'reflection'
                })
                .finally(() => {
                    vm.isSheetReflectionLoading = false;
                });
            if (from.name !== 'sheet-one-meeting') {
                vm.isSheetMeetingLoading = true;
                vm.$store
                    .dispatch('sheet/loadFinalSheet', {
                        familyId: vm.$route.params.familyId,
                        sheetType: 'meeting'
                    })
                    .finally(() => {
                        vm.isSheetMeetingLoading = false;
                    });
            }
            vm.$store.commit('sheet/setCurrentRouteName', to.name);
            vm.$store.commit('sheet/setCurrentSelectorName', 'calculate');
        });
    },
    data () {
        return {
            permissions,
            isSheetReflectionLoading: true,
            isSheetMeetingLoading: false
        };
    },
    computed: {
        showSeniorPack () {
            return this.$store.getters['sheet/getJoblessField']('aboutSixty') === 'yes';
        },
        sheetPermissions () {
            return this.$store.getters['sheet/getSheetPermissions'];
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        readOnly () {
            if (
                !this.canEditSheets ||
        (this.isFamilyVerifiedOnNational && !this.hasPermissionsForNationalCorrecting) ||
        !this.isCurrentEdition ||
        !this.isFamilyChecked
            ) {
                return true;
            }
            return !this.sheetPermissions.reflection;
        }
    },
    watch: {
        showSeniorPack: {
            immediate: true,
            handler (val) {
                if (val === true) {
                    this.$store.commit('sheet/removeHiddenSelector', 'seniorReflection');
                } else {
                    this.$store.commit('sheet/addHiddenSelector', 'seniorReflection');
                }
            }
        }
    },
    methods: {
        viewHandler (e) {
            if (e.scrollPercent < 1) {
                if (e.target.rect.top <= 50) {
                    this.$store.commit('sheet/setCurrentSelectorName', e.target.element.id);
                }
            } else {
                if (e.percentTop <= 1) {
                    this.$store.commit('sheet/setCurrentSelectorName', e.target.element.id);
                }
            }
        }
    }
};
</script>

<style scoped></style>
